import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {H2hWidgetConfig} from "./h2h-widget.config";
import {H2hWidgetState} from "./models/h2h-widget.state";

export class H2hWidgetStore extends BaseMobxStore {
  static injectables = [H2hWidgetConfig, H2hWidgetState];

  setActiveTab(index: Number) {
    this.state._tabsSelectedIndex = index;
  }
}

